import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { humanSize } from "@/lib/upload";
import { HardDrive } from "lucide-react";

const KIND_COLORS = { pdf: "bg-copper", image: "bg-info", video: "bg-navy", audio: "bg-success", file: "bg-ink-muted" };

export function StorageQuota() {
  const { db, storageUsage } = useApp();
  const [u, setU] = useState(null);
  useEffect(() => { storageUsage().then(setU).catch(() => setU(null)); }, [db.documents.length, storageUsage]);
  if (!u) return null;
  const pct = Math.min(100, (u.usedBytes / u.quotaBytes) * 100);
  return (
    <div className="mt-3 rounded-lg border border-line bg-card p-3" data-testid="storage-quota">
      <div className="flex items-center justify-between text-xs"><span className="flex items-center gap-1 font-medium text-ink"><HardDrive className="h-3.5 w-3.5 text-copper" />Storage</span><span className="text-ink-muted">{u.files} files</span></div>
      <div className="mt-2 flex h-2 overflow-hidden rounded-full bg-secondary">
        {Object.entries(u.byKind || {}).map(([k, b]) => <div key={k} className={KIND_COLORS[k] || KIND_COLORS.file} style={{ width: `${(b / u.quotaBytes) * 100}%` }} title={`${k}: ${humanSize(b)}`} />)}
      </div>
      <div className="mt-1.5 text-[11px] text-ink-2" data-testid="storage-quota-text"><b className="text-ink">{humanSize(u.usedBytes)}</b> of {humanSize(u.quotaBytes)} used · {pct.toFixed(1)}%</div>
      {u.trashBytes > 0 && <div className="text-[11px] text-ink-muted">{humanSize(u.trashBytes)} in Trash</div>}
      <div className="mt-1.5 flex flex-wrap gap-x-2 text-[10px] text-ink-muted">{Object.entries(u.byKind || {}).map(([k, b]) => <span key={k}><span className={`mr-1 inline-block h-2 w-2 rounded-sm ${KIND_COLORS[k] || KIND_COLORS.file}`} />{k} {humanSize(b)}</span>)}</div>
    </div>
  );
}
